import React from "react";
import useInput from "@ui/lib/hooks/useInput";
import t from "../../i18n";
import type { Project } from "../../api/useProjects";

export const useNameInput = (projects: Project[]) => {
  const hasSameValue = React.useMemo(
    () => [...new Set(projects.map(p => p.name).filter(d => d !== undefined))].length === 1,
    [projects],
  );

  const defaultValue = React.useMemo(() => {
    if (hasSameValue) return projects[0]?.name;
    return;
  }, [hasSameValue, projects]);

  const {
    value: nameValue,
    setValue: setInputName,
    onChange: handleNameChanged,
    dirty: isInputNameDirty,
    defaultValue: inputNameDefaultValue,
  } = useInput(defaultValue);

  // const handleRollbackName = React.useCallback(() => {
  //   setInputName(defaultValue);
  // }, [setInputName, defaultValue]);

  const placeholder = React.useMemo(() => {
    if (!hasSameValue && projects.length > 1) {
      return t("projects.modal.multiple_value");
    }
    if (defaultValue === "" || nameValue === "") {
      return t("projects.modal.name");
    }
    return defaultValue;
  }, [defaultValue, hasSameValue, nameValue, projects.length]);

  return {
    placeholder,
    nameValue,
    setInputName,
    handleNameChanged,
    isInputNameDirty,
    inputNameDefaultValue,
    // handleRollbackName,
  };
};
